import { Component, HostListener, OnInit, Renderer2 } from '@angular/core';
import { Router } from '@angular/router';
import { MenuItem } from 'primeng/api';
import { AppComponent } from 'src/app/app.component';
import { SessionService } from 'src/app/core/auth/session.service';
import { ApiService } from 'src/app/core/http/api.service';
import { MainLayoutComponent } from '../../main-layout/main-layout.component';
import { AppBreadcrumbService } from '../../Services/app.breadcrumb.service';
import { AuthService } from 'src/app/core/auth/auth.service';
import { ApiCore } from 'src/app/config/api';
import { JwtService } from 'src/app/core/auth/jwt.service';

@Component({
  selector: 'app-menu',
  templateUrl: './app.menu.component.html',
})
export class AppMenuComponent implements OnInit {
  public model: MenuItem[] = [];
  operatorLogo: string | null = 'assets/images/no-photo-available.png';
  showLoadSpin: boolean = false;

  showMenu: boolean = false;
  public operatorId: string = '';
  public operatorType: string = '';

  constructor(
    public app: AppComponent,
    public appMain: MainLayoutComponent,
    private auth: AuthService,
    private apiService: ApiService,
    private router: Router,
    private session: SessionService,
    private jwt: JwtService,
    private renderer: Renderer2
  ) {}

  private clickedInside: boolean = false;
  loadingMenu: boolean = true;
  @HostListener('click')
  clickInside() {
    this.clickedInside = true;
  }

  @HostListener('document:click')
  clickOutside() {
    if (!this.clickedInside) {
      this.showMenu = false;
    }
    this.clickedInside = false;
  }

  ngOnInit() {
    this.loadingMenu = true;
    this.getCoorporateConfiguration();
    this.getAgentInformation();
    //console.log(this.operatorType)
  }

  setMenuData(data: any) {
    return data;
  }
  // param: array of routerLink of all items
  validateMenuExpand = (routes: Array<string>): boolean => {
    const res = routes.map((i) => this.router.url.includes(i));
    const active = res.find((i) => i === true);
    return active === true ? true : false;
  };

  public async getCoorporateConfiguration(operatorId?: string) {
    try {
      this.showLoadSpin = true;
      await this.apiService
        .GetOperatorConfig(/*operatorId*/)
        .subscribe((res) => {
          this.session.setItem('operatorLogo', res.data.logoUrl);
          this.operatorLogo = res.data.logoUrl;
          this.showLoadSpin = false;
          console.log(res);
          this.setFavicon(res.data.faviconOperatorUrl);
        });
    } catch (error) {
      alert('Error happened');
      console.error(error);
    }
  }
  public getToken(): string {
    const token = this.session.getItem('token');
    if (token == null) {
      return '';
    } else {
      return token;
    }
  }
  async getAgentInformation() {
    try {
      const res = await this.apiService
        .getOperatorId(this.auth.getToken())
        .toPromise();
      if (res && res.data && res.data.operatorId) {
        this.model = [
          {
            label: 'Dashboard',
            icon: 'pi pi-home',
            routerLink: '/app/dashboard',
          },
          {
            label: 'Agents',
            icon: 'pi pi-briefcase',
            expanded: this.validateMenuExpand([
              '/app/create-agent',
              '/app/registered-agents',
              '/app/agent-mobile',
            ]),
            items: [
              {
                label: 'Crear Agent',
                icon: 'pi pi-plus',
                routerLink: '/app/create-agent',
              },
              {
                label: 'Agents Registrados',
                icon: 'pi pi-users',
                routerLink: '/app/registered-agents',
              },
            ],
          },
          {
            label: 'Players',
            icon: 'pi pi pi-user',
            expanded: this.validateMenuExpand([
              '/app/registered-players',
              '/app/pc-players',
            ]),
            items: [
              {
                label: 'Players Registrados',
                icon: 'pi pi-users',
                routerLink: '/app/registered-players',
              },
              {
                label: 'PC Players',
                icon: 'pi pi-desktop',
                routerLink: '/app/pc-players',
              },
            ],
          },
          {
            label: 'Finanzas',
            icon: 'pi pi-chart-bar',
            expanded: this.validateMenuExpand([
              '/app/sales-of-credits',
              '/app/withdrawal-of-credits',
              '/app/bonus',
              '/app/bets',
              '/app/transactions',
            ]),
            items: [
              {
                label: 'Venta de Créditos',
                icon: 'pi pi-download',
                routerLink: '/app/sales-of-credits',
              },
              {
                label: 'Retiro de Créditos',
                icon: 'pi pi-upload',
                routerLink: '/app/withdrawal-of-credits',
              },
              {
                label: 'Bonos',
                icon: 'pi pi-plus-circle',
                routerLink: '/app/bonus',
              },
              {
                label: 'Apuestas',
                icon: 'pi pi-money-bill',
                routerLink: '/app/bets',
                disabled: true,
              },
              {
                label: 'Transacciones',
                icon: 'pi pi-sort-alt',
                routerLink: '/app/transactions',
              },
            ],
          },
          {
            label: 'Lobby',
            icon: 'pi pi-th-large',
            expanded: this.validateMenuExpand([
              '/app/game-catalog',
              '/app/slidders',
            ]),
            items: [
              {
                label: 'Catálogo de Juegos',
                icon: 'pi pi-box',
                routerLink: '/app/games-catalog',
              },
              {
                label: 'Sliders',
                icon: 'pi pi-images',
                routerLink: '/app/slidders',
              },
            ],
          },
          {
            label: 'Mis Créditos',
            icon: 'pi pi-wallet',
            expanded: this.validateMenuExpand([
              '/app/credit-reserve',
              '/app/bonuses-reserve',
            ]),

            items: [
              {
                label: 'Reserva de Bonos',
                icon: 'pi pi-database',
                routerLink: '/app/bonuses-reserve',
              },
              {
                label: 'Reserva de Créditos',
                icon: 'pi pi-database',
                routerLink: '/app/credit-reserve',
              },
            ],
          },
        ];
        this.operatorId = res.data.operatorId;

        const profileRes = await this.apiService
          .list(ApiCore.OPERATOR + '/me/')
          .toPromise();

        this.operatorType = profileRes.data.operatorUserRoleCat.name;
        if (this.operatorType == 'Master Agent') {
          this.model = this.model;
        } else {
          const decodedToken = this.jwt.getData(this.getToken(), 'permissions');
          const modulosPermitidos = await this.filtrarMenuPorPermisos(
            this.model,
            decodedToken
          );
          this.model = modulosPermitidos;
        }
      } else {
        console.error('No se pudo obtener el operatorId.');
      }
      this.loadingMenu = false;
    } catch (error) {
      console.error('Error:', error);
    }
  }

  filtrarMenuPorPermisos = (menu: any[], permisos: string[]): any[] => {
    const modulosPermitidos: any[] = [];

    menu.forEach((item) => {
      const moduloConPermisos = { ...item };
      if (permisos.includes(item.label)) {
        if (item.items) {
          const subItemsPermitidos = item.items.filter((subItem: any) =>
            permisos.includes(subItem.label)
          );
          moduloConPermisos.items = subItemsPermitidos;
        }
        modulosPermitidos.push(moduloConPermisos);
      } else if (item.items) {
        const subItemsPermitidos = this.filtrarMenuPorPermisos(
          item.items,
          permisos
        );
        if (subItemsPermitidos.length > 0) {
          moduloConPermisos.items = subItemsPermitidos;
          modulosPermitidos.push(moduloConPermisos);
        }
      }
    });

    return modulosPermitidos;
  };

  setFavicon(url: string): void {
    if (!url) return;
    const link: HTMLLinkElement | null =
      document.querySelector('link[rel="icon"]');
    if (link) {
      this.renderer.setAttribute(link, 'href', url);
    } else {
      const link = this.renderer.createElement('link');
      this.renderer.setAttribute(link, 'rel', 'icon');
      this.renderer.setAttribute(link, 'href', url);
      this.renderer.appendChild(document.head, link);
    }
  }
}
